import { useRouter } from 'next/router';
import Icon from '@components/common/assets';
import { useMatchReportCompanyPositions } from '@repository/match/report/useMatchReport';
import { CompanyTabEnum } from '@components/company/sn';
import { V2Route } from '@utils/routeUtil';
import classnames from 'classnames/bind';
import styles from './resumeBtn.module.scss';
const cx = classnames.bind(styles);

interface Props {
  positionSn: number | null;
  companySn: number | null;
}

const MatchingReportBtn = ({ positionSn, companySn }: Props) => {
  const router = useRouter();

  const { data: matchingPositions } = useMatchReportCompanyPositions(!!companySn, Number(companySn));
  const selectedPosition = matchingPositions?.positions.find(({ sn }) => sn === positionSn);

  const onClick = () => {
    router.push({
      pathname: V2Route.getCompanyChannelPage(Number(companySn)),
      query: { tab: CompanyTabEnum.REPORT, positionSn },
    });
  };

  const disabled = !selectedPosition;

  if (!positionSn || !companySn) return null;

  return (
    <>
      <button className={cx('matchingReportBtnArea', { disabled })} role="button" onClick={onClick} disabled={disabled}>
        <Icon name="bookGreen" width={32} height={32} />
        매칭 리포트 확인하기
      </button>
    </>
  );
};

export default MatchingReportBtn;
